import { inject, PLATFORM_ID, provideAppInitializer, EnvironmentProviders } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { firstValueFrom, of } from 'rxjs';
import { LimpiezaSesionService } from '@core/services/limpieza-sesion/limpieza-sesion.service';

export interface OpcionesEvaluacionSalidaSesion {
  limpiezaSesionService: LimpiezaSesionService;
  platformId: object;
}

/* Se debe esperar a que termine (no fire-and-forget): el router arranca a navegar justo después
   de que resuelvan los APP_INITIALIZER, y si el cierre de la sesión pendiente sigue en curso, el
   sesionResolver puede llamar a verificarSesion() antes de que el backend la elimine, recuperando
   la sesión vieja en vez de partir limpio. */
export function evaluarSalidaSesionAlArrancar(opciones: OpcionesEvaluacionSalidaSesion): Promise<void> {
  const { limpiezaSesionService, platformId } = opciones;

  if (!isPlatformBrowser(platformId)) {
    return firstValueFrom(of(undefined));
  }

  return firstValueFrom(limpiezaSesionService.evaluarSalidaAlCargar());
}

export function proveedorEvaluacionSalidaSesion(): EnvironmentProviders {
  return provideAppInitializer(() =>
    evaluarSalidaSesionAlArrancar({
      limpiezaSesionService: inject(LimpiezaSesionService),
      platformId: inject(PLATFORM_ID),
    }),
  );
}
